export default "__VITE_ASSET__B7MqQqWc__"